import { ImageCarousel } from '@shared-components/ImageCarousel/ImageCarousel';
import { WholesaleImageCarousel } from '@shared-components/ImageCarousel/WholesaleImageCarousel';

import { DEFAULT_IMG_OBJ } from '../Gallery.constants';
import type { SlideshowGalleryProps } from '../Gallery.entity';

import styles from './SlideshowGallery.module.css';

const SlideshowGallery = ({
  images,
  slideshowGalleryStrings,
  currentClickImgIndex,
  carouselProps,
  locale,
  isInspectionReport,
  isZoomEnabled,
  tenant,
}: SlideshowGalleryProps) => {
  const totalImgs = images.length;
  const size = tenant === 'purchasePro' ? 'pdpPurchaseProSlideshow' : 'largest';

  return (
    <div
      className={styles.container}
      data-inspection-report={isInspectionReport}
      data-test-id="slideshow-gallery"
    >
      {tenant === 'purchasePro' ? (
        <WholesaleImageCarousel
          strings={slideshowGalleryStrings}
          images={totalImgs ? images : [DEFAULT_IMG_OBJ]}
          positionIndex={currentClickImgIndex}
          shouldShowDotCarousel={false}
          index={0}
          size={size}
          carouselProps={carouselProps}
          isZoomEnabled={isZoomEnabled}
          isInspectionReport={isInspectionReport}
        />
      ) : (
        <ImageCarousel
          strings={slideshowGalleryStrings}
          images={totalImgs ? images : [DEFAULT_IMG_OBJ]}
          positionIndex={currentClickImgIndex}
          shouldShowDotCarousel={false}
          index={0}
          size={size}
          carouselProps={carouselProps}
          locale={locale || 'uk'}
          tenant={tenant}
        />
      )}
    </div>
  );
};

export default SlideshowGallery;
